export interface Props {
  orientation: Orientation
  disabled?: boolean
  id?: string
}

export enum Orientation {
  HORIZONTAL = 'Horizontal',
  VERTICAL = 'Vertical'
}
